import { atom, useSetAtom } from 'jotai';

import type { BSError } from '../error/BSError';

export interface ToastError {
  text: string;
  type: ToastType;
}

export const notificationState = atom<string | undefined>(undefined);

export const toastState = atom<ToastError[]>([]);

export const errorState = atom<BSError | undefined>(undefined);

export enum ToastType {
  info,
  warning,
  error,
}

export const useError = (showInToast = false): ((error: BSError) => BSError) => {
  const setToast = useSetAtom(toastState);
  const setError = useSetAtom(errorState);

  return showInToast
    ? (e: BSError) => {
        setToast((old) => [...old, { text: e.userFriendlyExplanation, type: ToastType.error }]);

        return e;
      }
    : (e: BSError) => {
        setError(e);

        return e;
      };
};
